if (typeof MUR == 'undefined')
	MUR = window.MUR = {};

MUR.animation = {
	'duration':4000
}

MUR.responsive = {
	'xl':1280,
	'ipad':1024,
	'md':768,
	'sc':767,
	'sm':550,
	'xs':400
}

jQuery(document).ready(function($){

	/* --- HELPER FUNCTIONS --- */
	MUR.isSmall = function(size){
		var comparison = MUR.responsive.sc;

		if (typeof size != 'undefined')
			comparison = MUR.responsive[size];

		var w = $(window).width();

		if (w <= comparison)
			return true;
		return false;
	}

	MUR.hideVideo = function(){
		var sm = this.isSmall();
		if (sm || Modernizr.touch)
			return true;
		return false;
	}

	MUR.videoStateCheck = function(){
		var
			$video = $('video'),
			state  = $video[0].readyState;

		if (state >= 3 || this.isVideoReady)
			return true;
		return false;
	}

	FastClick.attach(document.body);

	//Don't ajaxy the sub menu links
	//as they are 'internal' links
	$('.sub-menu a').addClass('no-ajaxy');

	/* -------- MODULES ------- */
	//These do not need to be re-initialized
	require('./modules/contact/validation');
	require('./modules/global/ajax-load');
	require('./modules/global/ga');

	//Neighborhood related Util functions
	require('./../../assets/js/acf-set-location.js');

	var Modules = {
		LazyLoad    : require('./modules/global/lazy-load'),

		/*
		 * Need to keep this order
		 * intro > scroll > video > scroll util
		 */
		Intro       : require('./modules/home/intro'),
		Scroll      : require('./modules/global/scroll'),
		Video       : require('./modules/global/video'),
		ScrollUtil  : require('./modules/global/scroll-util'),
		/* ~ */

		ScrollDown  : require('./modules/global/scroll-down'),

		Form        : require('./modules/contact/form'),
		Selects     : require('./modules/contact/selects'),

		VideoHero   : require('./modules/u2/video-hero'),

		Interations : require('./modules/u1/interactions'),
		Waypoints   : require('./modules/u1/waypoints'),

		Header      : require('./modules/home/header'),

		Footer      : require('./modules/home/footer'),

		Legal       : require('./modules/global/modal'),
		Nav         : require('./modules/global/nav'),
		NavMinimize : require('./modules/global/nav-minimize'),
		Gallery     : require('./modules/global/gallery'),

		Views       : require('./modules/views/views'),

		Map         : require('./modules/neighborhood/map'),
		Waypoints2  : require('./modules/neighborhood/waypoints'),

		Press       : require('./modules/press/press'),

		AjaxPagination: require('./modules/progress/ajax-pagination'),

		Slideshow : require('./modules/global/slideshow')
	}

	for (module in Modules){
		Modules[module].init();
	}

	/* ---- AJAX load triggered re-instantiation --- */
	$('body').on('AJAX__reload',function(){

		//Kill all event handlers attached to body
		$(window)
			.off('scroll')
			.off('resize');

		$('body')
			.off('fullPage__afterLoad')
			.off('fullPage__onLeave')
			.off('fullPage__afterRender')
			.off('fullPage__disableInteractions')
			.off('fullPage__enableInteractions');

		//Give new sub menu a class
		$('.sub-menu a').addClass('no-ajaxy');

		//Reinstantiate
		for (module in Modules){
			var M = Modules[module];

			try{
				M.drop.call(M);
			} catch(e){}

			M.init.call(M);
		}
	});
});
